module.exports = __webpack_public_path__ + "static/img/phoneTop.1d70792f.png";